'use client'

import { HomeLink } from '@/components/home-link'
import { Button } from '@/components/ui/button'
import medalIcon from '@/public/icons/medal-2.svg'
import monitorIcon from '@/public/icons/monitor.svg'
import wavyLineImg from '@/public/img/wavy-line.svg'
import { ChevronRight } from 'lucide-react'
import Image from 'next/image'
import { HeroBf } from './hero-bf'

export default function Hero() {
  // Data limite: 27 de dezembro de 2025 às 8:00
  const limitDate = new Date('2025-12-27T08:00:00')
  const now = new Date()
  const showBfHero = now < limitDate

  if (showBfHero) {
    return (
      <>
        <HeroBf />
        {/* <div className="hidden lg:block">
        </div>

        <div className="block lg:hidden">
          <HeroBfMobile />
        </div> */}
      </>
    )
  }

  return (
    <div className="flex flex-wrap items-center justify-evenly">
      <div className="mx-auto w-full px-4 text-center md:px-0 lg:max-w-160 lg:text-left xl:mx-0 xl:max-w-md">
        <div className="mx-auto max-w-108 space-y-3 lg:mx-0 lg:space-y-2">
          <div className="flex items-stretch justify-center gap-2 font-manrope lg:justify-start">
            <div className="flex min-w-0 flex-1 items-center justify-center gap-2 rounded-lg bg-gray-200 px-3 py-3 lg:mx-0 lg:max-w-60 lg:flex-none lg:justify-start lg:gap-3 lg:p-4">
              <div className="shrink-0 rounded-full bg-orange-400 p-2">
                <Image
                  alt="Ícone de uma medalha"
                  height={16}
                  loading="lazy"
                  src={medalIcon}
                  width={16}
                />
              </div>
              <span className="text-center font-bold text-gray-900 text-sm leading-tight lg:text-left">
                100% Legalizado
              </span>
            </div>
            <div className="flex min-w-0 flex-1 items-center justify-center gap-2 rounded-lg bg-gray-200 px-3 py-3 lg:mx-0 lg:max-w-60 lg:flex-none lg:justify-start lg:gap-3 lg:p-4">
              <div className="shrink-0 rounded-full bg-orange-400 p-2">
                <Image
                  alt="Ícone de um monitor"
                  height={16}
                  loading="lazy"
                  src={monitorIcon}
                  width={16}
                />
              </div>
              <span className="text-center font-bold text-gray-900 text-sm leading-tight lg:text-left">
                Acesse como quiser
              </span>
            </div>
          </div>
          <h1 className="font-bold text-2.5xl text-primary-800 leading-tight lg:text-4.5xl lg:leading-none">
            Evolua na Maior escola de educadores da América Latina.
          </h1>
          <Image
            alt=""
            className="mx-auto w-[12.928125rem] sm:w-86.5 lg:mx-0 lg:ml-28 lg:w-86.5"
            src={wavyLineImg}
            unoptimized
          />
        </div>
        <div className="mt-4">
          <p className="font-medium text-gray-500 text-sm md:text-lg md:leading-7">
            Aprimore suas habilidades e mantenha-se atualizado com as práticas
            educacionais mais recentes.
          </p>
          <div className="mx-auto mt-4 flex flex-col gap-3 px-6 sm:max-w-80 sm:flex-row sm:items-center sm:gap-4 sm:px-0 lg:mx-0">
            <Button
              asChild
              className="min-h-10 bg-green-700 text-white sm:max-w-53"
              size="lg"
            >
              <HomeLink className="font-semibold text-sm" href={'/conta/novo'}>
                Comece Grátis
              </HomeLink>
            </Button>

            {/* Pós-Graduação — exibido somente no mobile (no desktop o acesso
                fica no menu superior). Replica a organização da Legado. */}
            <Button
              asChild
              className="w-full sm:hidden"
              size="lg"
              variant="outline"
            >
              <HomeLink
                className="font-semibold text-sm"
                href={'/cursos/pos-graduacoes'}
              >
                Pós-Graduação
              </HomeLink>
            </Button>

            <Button
              asChild
              className="w-full sm:w-1/2"
              id="courses-button"
              size="lg"
            >
              <HomeLink
                className="flex items-center justify-center gap-2 font-bold"
                href={'/cursos'}
              >
                Todos os cursos
                <ChevronRight strokeWidth={3} />
              </HomeLink>
            </Button>

            {/* <Image
            src={threeDashesImg}
            alt=""
            className="h-9.25 w-25.5 sm:h-12 sm:w-44.25 md:h-12 md:w-44.25"
          /> */}
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-17 pl-4 md:pl-0 xl:m-0 xl:pl-0">
        <div className="w-full">
          <Image
            alt="Homem usando um notebook"
            height={467.98}
            // placeholder='blur'
            // loading='lazy'
            // priority={true}
            quality="65"
            src="/img/home-hero-selo.webp"
            width={500}
          />
          {/* <Image
          src={risksImg}
          alt=""
          loading='lazy'
          width={156.75}
          height={128.32}
          className="absolute -left-5 -top-14 md:-left-25 md:-top-6"
        /> */}
        </div>
      </div>
    </div>
  )
}
